var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getMissionFunctionDef } from '../../../../backend/features/mission/shared';
import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useTypedPlatformFunction } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import useSWR from 'swr';
import { useMissionActions } from './useMissionActions';
export const missionFetchKey = 'mission';
export const useMission = ({ missionId, isVolunteerView }) => {
    const getMissionPlatformFn = useTypedPlatformFunction(getMissionFunctionDef);
    const fetchMissionEntity = (missionId, isVolunteerView) => __awaiter(void 0, void 0, void 0, function* () {
        return yield getMissionPlatformFn({
            missionId,
            isVolunteerView,
        });
    });
    const { closeMission: closeMissionAction, mobilizeMission: mobilizeMissionAction } = useMissionActions();
    const { data: mission, mutate, isLoading, } = useSWR([missionFetchKey, missionId, isVolunteerView], ([, paramsMissionId, paramsIsVolunteerView]) => {
        return fetchMissionEntity(paramsMissionId, paramsIsVolunteerView)
            .then((response) => {
            return response;
        })
            .catch(handleErrorSnackbar);
    }, defaultFetcherOptions);
    const closeMission = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!mission) {
            return;
        }
        yield closeMissionAction(missionId);
        return mutate();
    });
    const mobilizeMission = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!mission) {
            return;
        }
        yield mobilizeMissionAction(missionId);
        return mutate();
    });
    return {
        mission,
        isLoading,
        closeMission,
        mobilizeMission,
        fetchMission: mutate,
    };
};
